import DownloadButton from "../../../../../components/button/downloadButton/downloadButton";
import { IContractInformationResponse } from "../../../../../models/loan.model";


export default function Contract({ bankContract, internal }: IContractInformationResponse) {
    return (
        <>
            {(internal != null && internal != undefined) ?
                <DownloadButton title={internal?.title} downloadLink={internal?.file}></DownloadButton>
                : <></>}
            {(bankContract != null && bankContract != undefined) ?
                <DownloadButton title={bankContract?.title} downloadLink={bankContract?.file}></DownloadButton>
                : <></>}
        </>
    )
}